{
  "version": 1,
  "asset_id": "56184f97-0f58-463e-b960-f11cd664a025",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/56184f97-0f58-463e-b960-f11cd664a025/hero-consultation.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/56184f97-0f58-463e-b960-f11cd664a025/hero-consultation.jpg",
  "original_filename": "hero-consultation.jpg",
  "size": 114977,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:37:59Z"
}
